<div class="flex flex-wrap gap-2">
  <p-button
    [disabled]="!form.valid || saveDisabled"
    [label]="'ACTIONS.SAVE' | translate"
    icon="fal fa-save"
    type="submit"></p-button>
  <p-button
    (onClick)="cancel()"
    [label]="'ACTIONS.CANCEL' | translate"
    icon="fal fa-times"
    styleClass="p-button-secondary"
    type="button"></p-button>
  <ng-content></ng-content>
</div>
